import { render, staticRenderFns } from "./LicenseRestrictedNotice.vue?vue&type=template&id=6ab60a89&scoped=true&"
import script from "./LicenseRestrictedNotice.vue?vue&type=script&lang=js&"
export * from "./LicenseRestrictedNotice.vue?vue&type=script&lang=js&"
import style0 from "./LicenseRestrictedNotice.vue?vue&type=style&index=0&id=6ab60a89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab60a89",
  null
  
)

export default component.exports